import { Menu, rem } from "@mantine/core"
import { IconAddressBook, IconBracketsContain, IconContract, IconTableOptions } from "@tabler/icons-react"

import { NavbarButtonWithMenu } from "@/components/generic/SideNavBar/components/NavbarButtonWithMenu/NavbarButtonWithMenu"
import Link from "next/link"
import { useTranslations } from "next-intl"

interface NavbarContactsButtonProps {
  isSelected: boolean
  label: string
}

export function NavbarContactsButton({ isSelected, label }: NavbarContactsButtonProps) {
  const t = useTranslations("sideNavBar")

  return (
    <NavbarButtonWithMenu icon={IconAddressBook} isSelected={isSelected} label={label}>
      <Menu.Dropdown miw={200}>
        <Menu.Item leftSection={<IconBracketsContain style={{ width: rem(14), height: rem(14) }} />} component={Link} href={"/contact/properties/library"}>
          {t("contacts.properties")}
        </Menu.Item>
        <Menu.Item leftSection={<IconTableOptions style={{ width: rem(14), height: rem(14) }} />} component={Link} href={"/contact/lists/library"}>
          {t("contacts.lists")}
        </Menu.Item>
        <Menu.Item leftSection={<IconContract style={{ width: rem(14), height: rem(14) }} />} component={Link} href={"/contact/bulk/editor"}>
          {t("contacts.bulkEditor")}
        </Menu.Item>
      </Menu.Dropdown>
    </NavbarButtonWithMenu>
  )
}
